import { render, staticRenderFns } from "./feature-grid.vue?vue&type=template&id=4226d1cc&scoped=true&"
import script from "./feature-grid.vue?vue&type=script&lang=js&"
export * from "./feature-grid.vue?vue&type=script&lang=js&"
import style0 from "./feature-grid.vue?vue&type=style&index=0&id=4226d1cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4226d1cc",
  null
  
)

export default component.exports